import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import Flex from 'components/Flex'

const backdropFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.7;
  }
`

const backdropFadeOut = keyframes`
  from {
    opacity: 0.7;
  }
  to {
    opacity: 0;
  }
`

const ModalBackdrop = styled(Flex)`
  position: fixed;
  top: 0;
  left: 0;
  background-color: black;
  height: 100%;
  width: 100%;
  overflow: hidden;
  opacity: 0.7;
  animation-name: ${props => props.show ? backdropFadeIn : backdropFadeOut};
  animation-duration: ${props => props.transitionDuration}ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  pointer-events: all;
`
ModalBackdrop.propTypes = {
  show: PropTypes.bool.isRequired,
  transitionDuration: PropTypes.number.isRequired
}

export default ModalBackdrop
